import { NavigationItems } from '@/types';

// sidebar: visible nav items
export const NAV_ITEMS: Record<NavigationItems, NavigationItems> = {
  dashboard: 'dashboard',
  home: 'home',
  cards: 'cards',
  list: 'list',
  'tax-reporting': 'tax-reporting',
  help: 'help',
  complaints: 'complaints',
};

// items that work like nav items, but are not in the sidebar nav
export const OTHER_NAV_ITEMS = {
  PROFILE: 'profile',
  LEGAL: 'legal',
  LOGIN: 'login',
};
